import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * Payment-Link Link-Tester — Teaser-Hinweis (Spec 501, Phase 5).
 *
 * Einheitlicher Hinweis fuer alle scharfen Pfade, solange keine Format-Definition
 * geladen ist („Format-Spezifikation angefordert"). Bewusst neutral formuliert —
 * nichts hier bestaetigt eine funktionierende Signatur (Spec §Teaser-Verhalten).
 */
export function TeaserNotice({ text }: { text?: string }) {
  const { t } = useTranslation('payment-link');
  return (
    <div
      role="status"
      className="flex items-start gap-2 rounded-md border border-dashed border-muted-foreground/40 bg-muted/40 p-3 text-sm text-muted-foreground"
    >
      <Info className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <span>{text ?? t('tester.teaser.hint')}</span>
    </div>
  );
}
